import React, { useState, memo } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Zap, Users, CreditCard, Calendar, Settings, BarChart, Mail, Shield, Globe, Smartphone, Clock, Image, Award, HelpCircle, FileText, UserPlus, DollarSign, Percent, Camera, ChevronLeft, ChevronRight, TrendingUp } from 'lucide-react';
export function RegistrationFeatures() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    icon: <Zap className="h-10 w-10 text-yellow-300" data-id="element-1941" />,
    title: 'Ready to Revolutionize Your Race Registration?',
    content: "Say goodbye to overpriced, cluttered features! With RaceLookup, you get all the essentials at the best price. Our seamless, user-friendly platform is designed by race directors specifically for your event's needs.",
    content2: "Join the race to success with the industry's best-kept secret! Register today and unlock the perfect features for your online race—don't miss out!",
    tagline: 'RaceLookup – Where Winning Registration Begins!',
    cta: 'Start here and watch your success soar!'
  }, {
    icon: <BarChart className="h-10 w-10 text-yellow-300" data-id="element-1942" />,
    title: "Unlock Your Event's Potential with RaceLookup Data-Driven Analytics!",
    content: 'Take your event to the next level with cutting-edge analytics, stunning reports, and effortless exports. Gain valuable insights into performance, track conversions like a pro, and visualize your data with beautiful dashboards and charts.',
    content2: "Don't just run events—master them!",
    tagline: null,
    cta: 'Start here and watch your success soar!'
  }, {
    icon: <DollarSign className="h-10 w-10 text-yellow-300" data-id="element-1943" />,
    title: "Unlock Valuable Cash with RaceLookup's Instant Payouts!",
    content: 'Say goodbye to waiting weeks or months for your event revenue. With instant funding and daily, weekly, or monthly payouts, you can enjoy your earnings immediately.',
    content2: 'Get ready to enjoy the rewards of your hard work instantly!',
    tagline: null,
    cta: 'Start here and watch your success soar!'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <div className="w-full bg-gray-50" data-id="element-1944">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0E578E] to-[#01AAE7] py-16 sm:py-20 overflow-hidden" data-id="element-1945">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 opacity-10" data-id="element-1946">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" data-id="element-1947"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-1948"></div>
        </div>

        {/* Diagonal Lines Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
      }} data-id="element-1949"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-1950">
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" data-id="element-1951">
            Registration Features
            <span className="block mt-2 bg-gradient-to-r from-white via-cyan-100 to-white bg-clip-text text-transparent" data-id="element-1952">
              Built for Race Directors
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-1953">
            RaceLookup delivers a modern registration experience that works the
            way you do. Customize every step, keep your athletes informed, and
            manage critical data in one secure platform.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1954">
            <Link to="/create-account" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-base" data-id="element-1955">
              Create a Free Account
            </Link>
            <Link to="/sign-in" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold rounded-xl hover:bg-white/20 transition-all text-base" data-id="element-1956">
              List Your Event
            </Link>
          </div>
        </div>
      </section>

      {/* Spacer */}
      <div className="py-8 sm:py-12 bg-gray-50" data-id="element-1957"></div>

      {/* Ready to Revolutionize Section - Slider */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-1958">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1959">
          {/* Slider Container */}
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-1960">
            {/* Animated Background */}
            <div className="absolute inset-0 opacity-10" data-id="element-1961">
              <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" data-id="element-1962"></div>
              <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-yellow-300 rounded-full blur-3xl animate-pulse" style={{
              animationDelay: '1s'
            }} data-id="element-1963"></div>
            </div>

            {/* Slider Content */}
            <div className="relative z-10 px-8 sm:px-12 lg:px-16 py-12 sm:py-16" data-id="element-1964">
              <div className="text-center" data-id="element-1965">
                {/* Icon and Title */}
                <div className="mb-8" data-id="element-1966">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-300/20 backdrop-blur-sm rounded-2xl border-2 border-yellow-300/30 mb-6" data-id="element-1967">
                    {slides[currentSlide].icon}
                  </div>
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-white leading-tight max-w-3xl mx-auto" data-id="element-1968">
                    {slides[currentSlide].title}
                  </h2>
                </div>

                {/* Content */}
                <div className="max-w-3xl mx-auto space-y-4 mb-8" data-id="element-1969">
                  <p className="text-base sm:text-lg text-white/90 leading-relaxed" data-id="element-1970">
                    {slides[currentSlide].content}
                  </p>
                  <p className="text-base sm:text-lg text-white/95 leading-relaxed font-semibold" data-id="element-1971">
                    {slides[currentSlide].content2}
                  </p>
                </div>

                {/* Tagline */}
                {slides[currentSlide].tagline && <div className="mb-8" data-id="element-1972">
                    <div className="inline-flex items-center gap-3 bg-yellow-300/20 backdrop-blur-sm border-2 border-yellow-300/40 rounded-xl px-5 py-3" data-id="element-1973">
                      <Clock className="h-6 w-6 text-yellow-300 flex-shrink-0" data-id="element-1974" />
                      <p className="text-lg sm:text-xl font-black text-yellow-300" data-id="element-1975">
                        {slides[currentSlide].tagline}
                      </p>
                    </div>
                  </div>}

                {/* CTA Button */}
                <div className="mb-10" data-id="element-1976">
                  <Link to="/create-account" className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-white text-blue-700 font-bold rounded-xl hover:bg-yellow-300 hover:text-blue-900 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-base sm:text-lg" data-id="element-1977">
                    <span data-id="element-1978">{slides[currentSlide].cta}</span>
                    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1979" />
                  </Link>
                </div>

                {/* Navigation Controls */}
                <div className="flex items-center justify-center gap-6" data-id="element-1980">
                  <button onClick={prevSlide} className="w-12 h-12 bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-full flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all" aria-label="Previous slide" data-id="element-1981">
                    <ChevronLeft className="h-6 w-6 text-white" data-id="element-1982" />
                  </button>

                  {/* Dots Indicator */}
                  <div className="flex items-center gap-3" data-id="element-1983">
                    {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`transition-all ${index === currentSlide ? 'w-10 h-3 bg-white rounded-full' : 'w-3 h-3 bg-white/40 rounded-full hover:bg-white/60 hover:scale-125'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1984" />)}
                  </div>

                  <button onClick={nextSlide} className="w-12 h-12 bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-full flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all" aria-label="Next slide" data-id="element-1985">
                    <ChevronRight className="h-6 w-6 text-white" data-id="element-1986" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1987">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1988">
          <div className="text-center mb-12" data-id="element-1989">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1990">
              Key Features
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1991">
            {/* Feature 1 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1992">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1993">
                <Settings className="h-7 w-7 text-white" data-id="element-1994" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1995">
                Customizable Registration Journeys
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1996">
                Build participant flows that mirror your event. Configure
                registration steps, enable conditional questions, support
                multi-participant registrations, and pair each race category
                with the right add-ons and waivers.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-1997">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1998">
                <DollarSign className="h-7 w-7 text-white" data-id="element-1999" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-2000">
                Flexible Pricing & Discounts
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-2001">
                Launch early-bird pricing, bundle add-ons, create promo codes,
                and manage donations—all in one place. Every transaction flows
                through Stripe so you can get paid as you go.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-2002">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-2003">
                <Clock className="h-7 w-7 text-white" data-id="element-2004" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-2005">
                Integrated Timing & Results
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-2006">
                Sync seamlessly with Race Result—no spreadsheets required. Push
                athletes, retrieve bibs, and publish live results within minutes
                to keep athletes, timers, and spectators informed.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-2007">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-2008">
                <Mail className="h-7 w-7 text-white" data-id="element-2009" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-2010">
                Communication & Engagement Tools
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-2011">
                Automate confirmation emails, send payment reminders, and share
                key updates right from your dashboard. Built-in messaging keeps
                participants engaged from registration through race day.
              </p>
            </div>

            {/* Feature 5 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-2012">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-2013">
                <Shield className="h-7 w-7 text-white" data-id="element-2014" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-2015">
                Data You Control
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-2016">
                Export participant data, collect emergency contacts, manage
                custom fields, and stay compliant with privacy standards. You
                decide what to collect and how to use it.
              </p>
            </div>

            {/* Feature 6 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100 hover:border-[#01AAE7] transition-all" data-id="element-2017">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-2018">
                <Users className="h-7 w-7 text-white" data-id="element-2019" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-2020">
                Volunteer & Team Support
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-2021">
                Manage volunteer options, enable team registrations, and track
                corporate or club participation. RaceLookup reduces manual work
                so you can focus on creating a memorable event.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* More Features Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-2022">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-2023">
          <div className="text-center mb-12" data-id="element-2024">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-2025">
              More Features
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2026">
              A deeper dive into the RaceLookup toolbox. Click on any card to
              learn how each feature elevates your event.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2027">
            {/* Photo Management */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2028">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2029">
                <Camera className="h-6 w-6 text-white" data-id="element-2030" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2031">
                Photo Management
              </h3>
            </div>

            {/* Bib Assignment */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2032">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2033">
                <Award className="h-6 w-6 text-white" data-id="element-2034" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2035">
                Bib Assignment Management
              </h3>
            </div>

            {/* Certificate Management */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2036">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2037">
                <FileText className="h-6 w-6 text-white" data-id="element-2038" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2039">
                Certificate Management
              </h3>
            </div>

            {/* Registration Add-on */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2040">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2041">
                <Settings className="h-6 w-6 text-white" data-id="element-2042" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2043">
                Registration Add-on Management
              </h3>
            </div>

            {/* Integration Management */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2044">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2045">
                <Globe className="h-6 w-6 text-white" data-id="element-2046" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2047">
                Integration Management
              </h3>
            </div>

            {/* Registration Question */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2048">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2049">
                <HelpCircle className="h-6 w-6 text-white" data-id="element-2050" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2051">
                Registration Question Management
              </h3>
            </div>

            {/* Embed and Share */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2052">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2053">
                <Globe className="h-6 w-6 text-white" data-id="element-2054" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2055">
                Embed and Share
              </h3>
            </div>

            {/* Waiver Management */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2056">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2057">
                <FileText className="h-6 w-6 text-white" data-id="element-2058" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2059">
                Waiver Management
              </h3>
            </div>

            {/* Pacer Management */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2060">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2061">
                <Clock className="h-6 w-6 text-white" data-id="element-2062" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2063">
                Pacer Management
              </h3>
            </div>

            {/* Volunteer Management */}
            <div className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all cursor-pointer group" data-id="element-2064">
              <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-2065">
                <Users className="h-6 w-6 text-white" data-id="element-2066" />
              </div>
              <h3 className="text-base font-black text-gray-900" data-id="element-2067">
                Volunteer Management
              </h3>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Management Details Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-2068">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-2069">
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 sm:p-10 border-2 border-blue-100" data-id="element-2070">
            <div className="flex items-center gap-4 mb-6" data-id="element-2071">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center" data-id="element-2072">
                <Camera className="h-8 w-8 text-white" data-id="element-2073" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-black text-gray-900" data-id="element-2074">
                Photo Management Details
              </h2>
            </div>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-2075">
              Capture the excitement of race day and share it instantly. Upload
              galleries, tag bibs automatically, and showcase sponsor placements
              without leaving the RaceLookup dashboard.
            </p>
            <ul className="space-y-3" data-id="element-2076">
              <li className="flex items-start gap-3" data-id="element-2077">
                <CheckCircle2 className="h-6 w-6 text-[#01AAE7] flex-shrink-0 mt-0.5" data-id="element-2078" />
                <span className="text-gray-700" data-id="element-2079">
                  Batch upload or link external albums
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2080">
                <CheckCircle2 className="h-6 w-6 text-[#01AAE7] flex-shrink-0 mt-0.5" data-id="element-2081" />
                <span className="text-gray-700" data-id="element-2082">
                  Tag participants by bib for quick search
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2083">
                <CheckCircle2 className="h-6 w-6 text-[#01AAE7] flex-shrink-0 mt-0.5" data-id="element-2084" />
                <span className="text-gray-700" data-id="element-2085">
                  Share highlight reels with sponsors and media
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Other Key Modules Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-2086">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-2087">
          <div className="text-center mb-12" data-id="element-2088">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-2089">
              Other Key Modules
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2090">
            <Link to="#" className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all group" data-id="element-2091">
              <h3 className="text-lg font-black text-gray-900 mb-2 group-hover:text-[#01AAE7] transition-colors" data-id="element-2092">
                Runner Profile
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-2093">
                Manage participant information and history
              </p>
              <span className="text-[#01AAE7] text-sm font-bold inline-flex items-center gap-1" data-id="element-2094">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-2095" />
              </span>
            </Link>

            <Link to="#" className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all group" data-id="element-2096">
              <h3 className="text-lg font-black text-gray-900 mb-2 group-hover:text-[#01AAE7] transition-colors" data-id="element-2097">
                Business Profile
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-2098">
                Customize your event organizer profile
              </p>
              <span className="text-[#01AAE7] text-sm font-bold inline-flex items-center gap-1" data-id="element-2099">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-2100" />
              </span>
            </Link>

            <Link to="#" className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all group" data-id="element-2101">
              <h3 className="text-lg font-black text-gray-900 mb-2 group-hover:text-[#01AAE7] transition-colors" data-id="element-2102">
                Registration Management
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-2103">
                Control all aspects of participant registration
              </p>
              <span className="text-[#01AAE7] text-sm font-bold inline-flex items-center gap-1" data-id="element-2104">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-2105" />
              </span>
            </Link>

            <Link to="#" className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all group" data-id="element-2106">
              <h3 className="text-lg font-black text-gray-900 mb-2 group-hover:text-[#01AAE7] transition-colors" data-id="element-2107">
                Group Registration
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-2108">
                Enable team and corporate registrations
              </p>
              <span className="text-[#01AAE7] text-sm font-bold inline-flex items-center gap-1" data-id="element-2109">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-2110" />
              </span>
            </Link>

            <Link to="#" className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all group" data-id="element-2111">
              <h3 className="text-lg font-black text-gray-900 mb-2 group-hover:text-[#01AAE7] transition-colors" data-id="element-2112">
                Fee Management
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-2113">
                Configure pricing tiers and add-ons
              </p>
              <span className="text-[#01AAE7] text-sm font-bold inline-flex items-center gap-1" data-id="element-2114">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-2115" />
              </span>
            </Link>

            <Link to="#" className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-[#01AAE7] transition-all group" data-id="element-2116">
              <h3 className="text-lg font-black text-gray-900 mb-2 group-hover:text-[#01AAE7] transition-colors" data-id="element-2117">
                Discount Management
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-2118">
                Create and manage promotional codes
              </p>
              <span className="text-[#01AAE7] text-sm font-bold inline-flex items-center gap-1" data-id="element-2119">
                Learn More <ArrowRight className="h-4 w-4" data-id="element-2120" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      {/* Demo CTA Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] relative overflow-hidden" data-id="element-2121">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-2122">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-2123"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-2124"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-2125">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-6" data-id="element-2126">
            Need a Hands-On Demo?
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-2127">
            We'd love to walk you through the platform. Schedule a tour or jump
            right in—RaceLookup makes it easy either way.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2128">
            <Link to="/contact" className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-base" data-id="element-2129">
              <span data-id="element-2130">Contact Us</span>
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-2131" />
            </Link>

            <Link to="/create-account" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold rounded-xl hover:bg-white/20 transition-all text-base" data-id="element-2132">
              View the RaceLookup Overview
            </Link>
          </div>
        </div>
      </section>
    </div>;
}